const text = `thoughts before language

they move without direction
floating in the dark
unnamed and formless

you are gravity

i drift toward you
slowly at first
then all at once

still`;

export default text;
